import {gsap} from "../../../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';

// Constructor
export class GameBDraggableItem extends PIXI.Container {

  constructor(asset, hasIdleAnimation, offsetX, offsetY, game) {
    super();

    // top left position
    this.pos = {
      x: 2252,
      y: 1458
    }

    this.lastMoveX = 0;
    this.offset = {x: offsetX, y: offsetY}
    this.offsetFix = {x: -50, y: 5}; // offset fix due to new asset size when adding padding inside the png

    this.game = game;

    this.startDragPosition = new PIXI.Point(0, 0);
    this.targetDragPosition = game.mainCharacter.toGlobal(new PIXI.Point(0, 0));
    this.targetDragPosition.x += (game.mainCharacter.width / 2);
    this.dragComplete = false;

    this.asset = asset;
    this.hasIdleAnimation = hasIdleAnimation;
    this.isIdling = false;
    this.noProgressTimer = false;

    this.pathTimeline = new gsap.timeline({paused: true});

    this.build(game);

    this.disable();

  }

  build(game) {
    // we'll add a transparent background that will be used for dragging because we can't rely on the actual stage
    // because of the popup container blocking the interaction
    this.background = new PIXI.Container();

    this.backgroundGraphics = new PIXI.Graphics().rect(0, 0, game.appWidth, game.appHeight).fill(0x000000);
    this.background.addChild(this.backgroundGraphics);
    this.background.alpha = 0;
    this.addChild(this.background);

    this.objectContainer = new PIXI.Container();
    this.objectContainer.position.set(this.pos.x, this.pos.y);
    this.addChild(this.objectContainer);

    this.sprite = new PIXI.Sprite(PIXI.Texture.from(this.asset));
    this.sprite.anchor.set(0.5, 0.5);
    this.sprite.position.set((this.sprite.width / 2 + this.offset.x) + this.offsetFix.x, (this.sprite.height / 2 + this.offset.y) + this.offsetFix.y);
    this.sprite._zIndex = 999999;
    this.objectContainer.addChild(this.sprite);

    this.startDragPosition = this.sprite.toGlobal(new PIXI.Point(0, 0));
    this.startDragPosition.y = 0; // we only work on X

    this.buildAnimation();

    if (this.hasIdleAnimation) {
      this.idleContainer = new PIXI.Container();
      this.objectContainer.addChild(this.idleContainer);
      this.idleContainer.alpha = 0;

      this.idleSprite = new PIXI.Sprite(PIXI.Texture.from(this.asset));
      this.idleSprite.anchor.set(0.5, 0.5);
      this.idleSprite.position.set(this.idleSprite.width / 2 + this.offsetFix.x, this.idleSprite.height / 2 + this.offsetFix.y);
      this.idleSprite._zIndex = 999998;
      this.idleSprite.alpha = 0.5;
      this.idleSprite.eventMode = "none";
      this.idleContainer.addChild(this.idleSprite);

      this.idleArrow = new PIXI.Sprite(game.assets["idle-arrow-1"]);
      this.idleArrow.position.set(90, 10);
      this.idleArrow.anchor.set(1, 1);
      // this.idleArrow.alpha = 1;
      this.idleArrow.eventMode = "none";
      this.idleContainer.addChild(this.idleArrow);

      this.idleArrow2 = new PIXI.Sprite(game.assets["idle-arrow-2"]);
      this.idleArrow2.position.set(-10, 460);
      this.idleArrow2.anchor.set(1, 1);
      this.idleArrow2.alpha = 0;
      this.idleArrow2.eventMode = "none";
      this.idleContainer.addChild(this.idleArrow2);

      this.buildIdleAnimation();
    }
  }

  buildAnimation() {

    // Animation from position to the cart
    this.pathTimeline.fromTo(this.sprite,
      {
        pixi: {
          scale: 1,
        }
      },
      {
        motionPath: {
          // path: "M1427,138.05s-259-141-626-138-735,378-801,506",
          path: `M${this.offset.x + 1427},${this.offset.y + 138.05}s-259-141-626-138-735,378-${this.offset.x + 801},${-this.offset.y + 506}`,
          offsetX: -1427 + (this.sprite.width / 2) + this.offsetFix.x,
          offsetY: -138 + (this.sprite.height / 2) + this.offsetFix.y,
          // alignOrigin: [0.5, 0.5],
        },
        pixi: {
          scale: 0.75,
        },
        ease: 'linear',
        duration: 1, // duration is fake as it is handled by the drag
        immediateRender: true,
        onComplete: () => {
          // console.log("Dragged to the cart");
          this.outAnimation.play();
        },
        onUpdate: () => {
          this.emit("progress", {currentProgress: this.pathTimeline.progress()});

          if (!this.dragComplete && this.pathTimeline.progress() >= 0.85) {
            // console.log("Dragged 95% to the cart, let's auto trigger");
            this.dragComplete = true;
            this.removeAllEvents();
            this.pathTimeline.tweenTo(1);
          }
        }
      }
    )

    // Animation when the item reached the cart
    this.outAnimation = gsap.fromTo(this.sprite,
      {
        pixi: {
          scale: 0.75,
        },
      },
      {
        pixi: {
          scale: 0,
        },
        ease: 'quad.out',
        duration: 0.5,
        paused: true,
        onStart: () => {
          this.emit("inCart", {});
        },
        onComplete: () => {
          // console.log("Completed");
          this.disable();
          this.emit("complete", {});
        }
      }
    )

  }

  buildIdleAnimation() {

    // Idle animation when no action for X seconds
    this.idleAnimationTimeline = gsap.timeline({
      defaults: {
        // repeat: -1,
        // immediateRender: true,
      },
      paused: true,
      repeat: -1,
    });

    // Fade in container
    this.idleAnimationTimeline.fromTo(this.idleContainer,
      {
        pixi: {
          alpha: 0
        },
      },
      {
        pixi: {
          alpha: 1
        },
        immediateRender: true,
        duration: 0.25,
        overwrite: "auto",
      }, 0);

    // Bounce idle arrow
    this.idleAnimationTimeline.fromTo(this.idleArrow,
      {
        pixi: {
          x: 60,
          y: -20,
          alpha: 1,
        }
      },
      {
        pixi: {
          x: 90,
          y: 10,
          alpha: 1,
        },
        duration: 1,
        ease: "sine.inOut",
        repeat: 2,
        yoyo: true,
        overwrite: "auto",
      })

    // Fade in second arrow
    this.idleAnimationTimeline.fromTo(this.idleArrow2,
      {
        pixi: {
          alpha: 0
        }
      },
      {
        pixi: {
          alpha: 1
        },
        duration: 0.5,
        immediateRender: true,
        overwrite: "auto",
      })

    // Move sprite to the cart
    this.idleAnimationTimeline.fromTo(this.idleSprite,
      {
        pixi: {
          scale: 1,
          alpha: 0.5
        }
      },
      {
        motionPath: {
          path: `M${this.offset.x + 1427},${this.offset.y + 138.05}s-259-141-626-138-735,378-${this.offset.x + 801},${-this.offset.y + 506}`,
          offsetX: -1427 + (this.idleSprite.width / 2) + this.offsetFix.x,
          offsetY: -138 + (this.idleSprite.height / 2) + this.offsetFix.y,
          // alignOrigin: [0.5, 0.5],
        },
        pixi: {
          scale: 0.5,
          alpha: 0.5
        },
        ease: 'linear',
        duration: 3,
        immediateRender: true,
        overwrite: "auto",
      })

    // Fade out everything
    this.idleAnimationTimeline.to(this.idleContainer,
      {
        pixi: {
          alpha: 0
        },
        duration: 0.5,
      })

  }

  startIdleMode() {
    if (!this.hasIdleAnimation) {
      return;
    }

    this.isIdling = true;
    this.idleAnimationTimeline.progress(0);
    this.idleAnimationTimeline.play();
  }

  stopIdleMode() {
    if (!this.hasIdleAnimation || !this.isIdling) {
      return;
    }

    this.isIdling = false;
    gsap.to([this.idleSprite, this.idleArrow, this.idleArrow2],
      {
        pixi: {
          alpha: 0
        },
        overwrite: "auto",
        duration: 0.5,
        onComplete: () => {
          this.idleAnimationTimeline.pause();
          this.idleAnimationTimeline.progress(0);
        }
      })
  }

  enable() {
    this.renderable = true;

    this.eventMode = "passive";
    this.sprite.eventMode = "static";
    this.background.eventMode = "none";

    this.removeAllEvents();
    this.sprite.on("pointerdown", this.onStartDrag, this);

    gsap.to(this.sprite,
      {
        pixi: {
          scale: 1,
        },
        ease: "back.out(1.7)",
        overwrite: "auto",
        duration: 0.5,
      }
    )
    gsap.set(this,
      {
        pixi: {
          alpha: 1,
        }
      }
    )

    if (this.hasIdleAnimation) {
      this.startNoActionTimer();
    }
  }

  disable(immediate) {
    let duration = typeof immediate !== "undefined" ? 0 : 0.5;

    this.eventMode = "none";
    this.sprite.eventMode = "none";
    this.background.eventMode = "none";

    this.removeAllEvents();

    gsap.to(this.sprite,
      {
        pixi: {
          scale: 0,
        },
        overwrite: "auto",
        duration: duration,
        onComplete: () => {
          this.renderable = false;
        }
      }
    )

    gsap.to(this,
      {
        pixi: {
          alpha: 0,
        },
        overwrite: "auto",
        duration: duration,
      }
    )
  }

  onStartDrag(e) {
    this.stopNoActionTimer();
    this.stopIdleMode();

    this.background.eventMode = "static";
    this.sprite.eventMode = "none";
    //
    this.background.on("pointermove", this.onMove, this);
    this.background.on("pointerup", this.onStopDrag, this)
    this.background.on("pointerupoutside", this.onStopDrag, this);
  }

  onMove(e) {
    let percentageMoved = window.map(e.client.x, this.startDragPosition.x, this.targetDragPosition.x, 0, 1);
    this.lastMoveX = Math.max(percentageMoved, this.lastMoveX);
    this.pathTimeline.progress(this.lastMoveX);
  }

  onStopDrag(e) {
    this.background.eventMode = "none";
    this.sprite.eventMode = "static";

    this.background.off("pointermove", this.onMove, this);
    this.background.off("pointerup", this.onStopDrag, this)
    this.background.off("pointerupoutside", this.onStopDrag, this);
  }

  removeAllEvents() {
    this.sprite.off("pointerdown", this.onStartDrag, this);
    this.background.off("pointermove", this.onMove, this);
    this.background.off("pointerup", this.onStopDrag, this)
    this.background.off("pointerupoutside", this.onStopDrag, this);
  }

  startNoActionTimer() {
    this.stopNoActionTimer();

    this.noProgressTimer = setTimeout(() => {
      this.startIdleMode();
    }, 5000)
  }

  stopNoActionTimer() {
    if (this.noProgressTimer !== false) {
      clearTimeout(this.noProgressTimer);
      this.noProgressTimer = false;
    }
  }

  reset() {
    this.stopIdleMode();
    this.stopNoActionTimer();

    this.disable();

    this.isIdling = false;
    this.dragComplete = false;
    this.lastMoveX = 0;

    this.pathTimeline.pause();
    this.pathTimeline.progress(0, true);

    this.outAnimation.pause();
    this.outAnimation.progress(0, true);

    if (this.hasIdleAnimation) {
      this.idleAnimationTimeline.pause();
      this.idleAnimationTimeline.progress(0, true);
    }
  }

}
